import React, { useCallback, useEffect, useState } from 'react';
import PageTitle from '../../layouts/PageTitle';
import '../../../scss/pages/_invoices-list.scss';
import logo from "../../../images/fhub_icon.png"

import {
    getInvoiceAction
} from '../../../store/actions/InvoiceAction';

import { useDispatch, useSelector } from 'react-redux';

const Invoices = () => {

    const dispatch = useDispatch();

    const allInvoices = useSelector((state) => state.allInvoices?.invoices?.payload);

    //console.log(allInvoices);

    function fetchAllInvoices() {
        dispatch(getInvoiceAction());
    }

    useEffect(() => {
        fetchAllInvoices();
    }, []);


 

    function getMonth(date) {
        const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        const d = new Date(date);
        let month = months[d.getMonth()];
        let day = d.getDate();

        return month + " " + day;
    }

    return (
        <div className='invoices'>
            <PageTitle
                title="Invoices"
                subtitle="Invoice overview"
            />



            <div className='invoice-top-portion'>
                <b className='pb-2 px-5'>INVOICES</b>
            </div>

            {allInvoices?.map(invoice =>
                <div>
                    <div className='mt-5 ml-3'>
                        <small>{invoice?.month}</small>
                    </div>
                    {invoice?.invoices?.map(item =>
                        <div className="card rounded-0 mt-2  mb-0">
                            <div className="card-body p-0">
                                <div className='row align-items-center p-3 mt-1 invoice-hover'>
                                    <div className="col-md-10 col-lg-10">
                                        <div className="d-flex invoice_body align-items-center">
                                            <img className='img-fluid' src={logo} />
                                            <div className='ml-3 d-grid'>
                                                <b>{ getMonth(item?.invoice_date)}</b>
                                                <small>{item?.branch?.name} - {item?.customer?.first_name + " " + item?.customer?.last_name} 4(s8dm) </small>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-2 col-lg-2 d-flex justify-content-end">
                                        <i className=' dropdown-toggle' data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> </i>

                                        <div className="dropdown-menu rounded-0">
                                            <li>
                                                <div className='d-flex  justify-content-between align-items-center invoice-drop-hoaver mr-1'>
                                                    <div className="d-flex justify-content-between align-items-center ">
                                                        <i className='mdi mdi-download mdi-18px'></i>
                                                        <span className='ml-3'>Invoice</span>
                                                    </div>
                                                    <span className='text-right pr-2'>PDF</span>
                                                </div>
                                            </li>
                                            <li>
                                                <div className='d-flex  justify-content-between align-items-center invoice-drop-hoaver mr-1'>
                                                    <div className="d-flex justify-content-between align-items-center ">
                                                        <i className='mdi mdi-download mdi-18px'></i>
                                                        <span className='ml-3'>Orders Summery</span>
                                                    </div>
                                                    <span className='text-right pr-2'>Excel</span>
                                                </div>
                                            </li>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                </div>

            )}

        </div>
    );
};

export default Invoices;